 (function($) {
 	$('.banner-slider').slick({
	    dots: true,
	    infinite: true,
	    speed: 400,
	    arrows: false,
	    cssEase: 'linear',
	    autoplay: true,
	    autoplaySpeed: 4000,
  	});
  	$('.department-carousel').slick({
	    dots: false,
	    infinite: true,
	    speed: 800,
	    arrows: true,
	    slidesToShow: 4,
  		slidesToScroll: 4,
  		prevArrow: '<span class="slick-prev slick-arrow"><i class="icon-angle-left"></span>',
  		nextArrow: '<span class="slick-next slick-arrow"><i class="icon-angle-right"></span>',
  		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		      }
		    },
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 650,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		]
  	});
  	$('.department-image-carousel').slick({
	    dots: false,
	    infinite: true,
	    speed: 800,
	    arrows: true,
	    slidesToShow: 3,
  		slidesToScroll: 3,
  		prevArrow: '<span class="slick-prev slick-arrow"><i class="icon-angle-left"></span>',
  		nextArrow: '<span class="slick-next slick-arrow"><i class="icon-angle-right"></span>',
  		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		      }
		    },
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 650,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		]
  	});
  	
  	$('.announcement-carousel').slick({
	    dots: false,
	    infinite: true,
	    speed: 500,
	    arrows: true,
	    cssEase: 'linear',
	    autoplay: true,
	    autoplaySpeed: 8000,
	    prevArrow: '<span class="slick-prev slick-arrow"><i class="icon-angle-left"></span>',
  		nextArrow: '<span class="slick-next slick-arrow"><i class="icon-angle-right"></span>',
  	});
  	$('.animate-it').addClass("animate-hidden").viewportChecker({
      classToAdd: 'animate-visible animated fadeInUp', // Class to add to the elements when they are visible
      offset: 100    
    });
    $(document).on('click', '.nav-toggle', function(e){
    	$(this).toggleClass('open');
    	$('html').toggleClass('nav-open');
    });
    $(document).on('click', '.mobile-main-navigation ul li.menu-item-has-children > a', function(e){
    	e.preventDefault();
    	$(this).next().slideToggle();
    });
    
    $(document).on('click','.scroll-to',function(e){
      e.preventDefault();
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top - 20;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 300);
    });
    $(document).on('click','.scroll-to-nav a',function(e){
      e.preventDefault();
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top - 20;
        $('.scroll-to-nav li').removeClass('active');
        $(this).parent().addClass('active');
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 300);
    });

  	$(window).on('scroll', function(){
  		var $el = $('.floating-nav');
  		if($el.length){
	  		var	ScrollPos = $(this).scrollTop(),
	  			TopPos = $el.parent().offset().top,
	  			Ptop = $el.parents('.right-sidebar-main').offset().top,
	  			elH = $el.height(),
	  			elW = $el.parent().width(),
	  			topVal = ScrollPos - TopPos,
	  			botOffset = $('.site-footer').offset().top,
	  			MT = botOffset- elH - Ptop;
	  		if(ScrollPos>=TopPos){
	  			$el.addClass('floating').css('width', elW);
	  		}else{
	  			$el.removeClass('floating').css('width', 'auto');
	  		}
	  		if((ScrollPos+elH)>=botOffset){
	  			var MT = botOffset- elH - Ptop;
	  			$el.addClass('floating-end').css('top', MT);
	  		}else{
	  			$el.removeClass('floating-end').css('top', '0');
	  		}
	  	}

  	});
  	$('.home-number-item .cnt-up').counterUp({
                delay: 10,
                time: 1000
            });

  	$(document).on('click', '.stk-amt-close', function(e){
  		e.preventDefault();
  		$(this).parent().fadeOut();
  	});
  	$(document).on('click', '.search-toggle', function(e){
  		e.preventDefault();
  		$('.mbcet-serach').addClass('search-on');
  		$('.mbcet-serach input').focus();
  	});
  	$(document).on('click', '.search-close', function(e){
  		e.preventDefault();
  		$('.mbcet-serach').removeClass('search-on');
  	});
  	$(document).on('click', '.mbcet-serach', function(event){
     	$el = $('.search-input-wrap');
     	if ($el.has(event.target).length == 0  && !$el.is(event.target)){
     		$('.mbcet-serach').removeClass('search-on');
     	}
    });
    $(document).on('click', 'a.enquiry-form-toggle', function(e){
  		e.preventDefault();
  		$('.enquiry-form').addClass('open');
  	});
  	$(document).on('click', 'a.enquiry-form-close', function(e){
  		e.preventDefault();
  		$('.enquiry-form').removeClass('open');
  	});
  	$(document).on('click', '.enquiry-form', function(event){
     	$el = $('.enquiry-form-in');
     	if ($el.has(event.target).length == 0  && !$el.is(event.target)){
     		$('.enquiry-form').removeClass('open');
     	}
    });
     /*--- Search auto complete ---*/

    var searchRequest;
	$('.search-autocomplete').autoComplete({
		minChars: 1,
	    source: function(term, suggest){
	    	try { searchRequest.abort(); } catch(e){}
			searchRequest = $.get( global.search_api, { term: term }, function( res ) {
				if ( res !== null ) {
					term = term.toLowerCase();
				        var suggestions = [];
				        for (i=0;i<res.length;i++){
				            suggestions.push([res[i]['post_title'],res[i]['guid']]);
				        }
				         suggest(suggestions);
				}
	        });
	    },
	    renderItem: function (item, search){
	        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
	        return '<div class="autocomplete-suggestion" data-value="'+item[0]+'" data-url="'+item[1]+'" data-val="'+search+'"> '+item[0].replace(re, "<b>$1</b>")+'</div>';
	    },
	    onSelect: function(e, term, item){
	        window.location.href = item.data('url')
	    }
	});
	$(".gridder").gridderExpander({
    scrollOffset: 60,
    scrollTo: "panel", // "panel" or "listitem"
    animationSpeed: 400,
    animationEasing: "easeInOutExpo",
    /*onStart: function () {
        console.log("Gridder Inititialized");
    },
    onExpanded: function (object) {
        console.log("Gridder Expanded");
    },
    onChanged: function (object) {
        console.log("Gridder Changed");
    },
    onClosed: function () {
        console.log("Gridder Closed");
    }*/
});
})(jQuery);